var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 310,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 302.5L145.871 7.2",
    stroke: "#E1ECF8",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 302.5l17.222-173.15M62.227 285.133l3.875-38.959 9.67-97.224M39.942 217.623l7.12-71.591M160.503 181.817l7.112-71.505M148.5 302.5l5.05-50.777M181.208 285.331l2.322-23.353a4.997 4.997 0 011.413-3.013l7.452-7.57a7.001 7.001 0 001.981-4.259l7.407-79.175a6.009 6.009 0 00-1.191-4.182l-5.264-6.949a4.999 4.999 0 01-.99-3.514L208.871 7.2M218.524 211.776l7.419-74.597",
    stroke: "#E1ECF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.339 95.243l66.253 4 26.591 1.606M86.987 116.531l134.943 8.148M91.809 140.003l117.212 7.077M22.5 159l219.9 13.277M28.54 183.546l202.671 12.236M55.13 208.332l50.914 3.074M177.885 215.744l58.515 3.533M53.664 233.425l148.817 8.985M78.308 261.154l120.354 7.267",
    stroke: "#E1ECF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.518 210a1.479 1.479 0 01-1.482-1.477v-11.809c0-.816.664-1.477 1.482-1.477s1.481.661 1.481 1.477v11.809c0 .816-.663 1.477-1.481 1.477z",
    fill: "#5F6E9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.094 210a1.48 1.48 0 01-1.482-1.477v-11.809a1.48 1.48 0 011.482-1.477c.818 0 1.481.661 1.481 1.477v11.809c0 .816-.663 1.477-1.481 1.477z",
    fill: "#414B82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.188 187.908a1.238 1.238 0 011.746.02 1.229 1.229 0 01-.021 1.741l-3.74 3.643c-.774.754-2.092.216-2.097-.875l-.023-4.61a.454.454 0 00-.453-.449h-.025v9.336h-6.539v-2.685l-2.061-.493a1.232 1.232 0 01-.947-1.197v-4.524c.009-1.598 1.33-2.899 2.945-2.899h6.627a2.925 2.925 0 012.922 2.899l.008 1.707 1.658-1.614zm-11.69-.083v3.543l.538.129v-4.119h-.063c-.256 0-.473.205-.475.447z",
    fill: "#FFB69E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.522 187.815a2.925 2.925 0 00-2.922-2.899h-2.126l.001.018c.03.645-.571 1.195-1.198 1.195-.671 0-1.169-.548-1.198-1.195v-.018h-2.106c-1.616 0-2.936 1.301-2.945 2.899v1.418h2.47v-1.408c.002-.242.219-.447.475-.447h.063v9.336h6.539v-9.336h.025c.248 0 .451.202.453.449l.006 1.406h2.469l-.006-1.418z",
    fill: "#64AFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.276 184.103a2.556 2.556 0 002.559-2.552A2.555 2.555 0 0098.276 179a2.555 2.555 0 00-2.558 2.551 2.555 2.555 0 002.558 2.552z",
    fill: "#FFB69E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.112 189.542a.596.596 0 01-.537-.861l1.418-2.882a.6.6 0 011.075.527l-1.418 2.881a.599.599 0 01-.538.335z",
    fill: "#6C9BAA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.63 194.615a1.23 1.23 0 00.287-2.428l-2.88-.69v2.532l2.305.552c.097.023.194.034.289.034z",
    fill: "#FFB69E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.426 119.512a1.314 1.314 0 01.204 1.884l-3.739 4.45a1.33 1.33 0 01-1.568.356v2.641h-6.976v-9.889l-3.599 1.203c-1.148.39-2.173-.844-1.569-1.888l3.595-6.204a1.323 1.323 0 011.798-.481 1.3 1.3 0 01.485 1.784l-1.847 3.189.447-.118c.213-.056.438-.084.659-.084h7.007c.676 0 1.336.249 1.884.671l3.219 2.486zm-5.103-.535v4.621l2.389-2.843-2.135-1.649a.618.618 0 00-.254-.129z",
    fill: "#FFB69E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.928 142.946a1.575 1.575 0 01-1.581-1.568v-12.535c0-.867.708-1.569 1.581-1.569s1.58.703 1.58 1.569v12.535c0 .866-.707 1.568-1.58 1.568z",
    fill: "#748488"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.743 142.946a1.575 1.575 0 01-1.581-1.568v-12.535c0-.867.708-1.569 1.581-1.569s1.58.703 1.58 1.569v12.535c0 .866-.707 1.568-1.58 1.568z",
    fill: "#55696E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.849 115.455a2.719 2.719 0 002.73-2.708 2.72 2.72 0 00-2.73-2.709 2.72 2.72 0 00-2.729 2.709 2.718 2.718 0 002.729 2.708z",
    fill: "#FFB69E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.207 117.026c-.548-.422-1.208-.671-1.884-.671H174.445c.035.867-.777 1.591-1.625 1.591-.908 0-1.581-.721-1.623-1.591h-1.883c-.222 0-.443.028-.658.085l-.446.117-1.936 3.424 3.074-1.027v9.889h6.975v-9.866a.618.618 0 01.254.129l1.603 1.238 1.661-2.055-1.634-1.263z",
    fill: "#64AFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 302.5l19.617-197.182c.519-5.42 4.954-8.996 10.383-8.586l41.694 2.82c6.459.436 12.101-4.33 12.749-10.772l7.928-78.785",
    stroke: "#2E8DDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.5 14a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM116.5 309a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    fill: "#2E8DDE"
  })));
}
export default SvgOnboarding2;